module.exports = __webpack_public_path__ + "img/12.9a256cd7.webp";